<template>
    <v-text-field
        v-model="date"
        :label="formattedLabel(question[`label${upperLocale}`] + '(' + this.getDateFormat + ')', required)"
        :aria-label="formattedAriaLabel($t('appt.accessibility.dateDescription.alternate'), required)"
        :rules="[
            !required || requiredField(),
            isExpectedDueDate ? v => !v || getFormRule('futureDate', 'base.errors.dateFuture')(v) :
            v => !v || getFormRule('pastDate', 'base.errors.datePast')(v),
            v => !v || getFormRule('validateDateIsInRange')(v, this.maxDate, this.minDate)
        ]"
        min-width="290px"
        v-facade="$t('base.dateMask')"
        @input="update"
    />
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { addDays, format } from 'date-fns';

export default {
    name: 'dynamic-date-input',
    props: {
        question: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),
        minDate() {
            switch(true) {
                case this.isExpectedDueDate: return format(addDays(new Date(), 1), 'YYYY-MM-DD');
                case this.isChildDateOfBirth: return '1913-01-01';
                default: return '1913-01-01';
            }
        },
        maxDate() {
            switch(true) {
                case this.isExpectedDueDate: return format(addDays(new Date(), 300), 'YYYY-MM-DD');
                case this.isChildDateOfBirth: return format(new Date(), 'YYYY-MM-DD');
                default: return '2123-01-01';
            }
        },
        isExpectedDueDate() {
            return this.question.typeSpecificType === 'birth';
        },
        isChildDateOfBirth() {
            return this.question.typeSpecificType === 'birthdate';
        },
        required() {
            return this.question.required;
        },
        getDateFormat() {
            return this.locale === 'fr' ? 'AAAA/MM/JJ' : 'YYYY/MM/DD';
        }
    },
    data: () => ({
        date: '',
    }),
    mixins: [formRules, inputHelpers],
    methods: {
        update(value) {
            this.$emit('updateQuestionResponse', { 'questionId': this.question.id, 'dynamicResponse': value });
        },
    },
};
</script>
